import styles from "./css/CompareEnergy.module.css";
import { AlternativeData } from "../../../types/alternative";
import { EnergyContent } from "./EnergyContent";
import { GreenLightningIcon } from "@/icons/GreenLightningIcon";
import { toatal_sqm } from "@/utils/alternative";
import { useTranslation } from "react-i18next";
interface CompareEnergyProps {
    alternatives: Set<AlternativeData>;
    bestAlternative: AlternativeData;
}

export const CompareEnergy: React.FC<CompareEnergyProps> = ({ alternatives, bestAlternative }) => {
    const { t } = useTranslation('CompareEnergy');


const consumptionColors = {
    energy_consumption: {
      "Value1": "#007AFF",
      "Value2": "#FF2D55",
      "Value3": "#FFCC00",
      "Value4": "#00C7BE",
    },
    energyProduction: {
        "Value1": "#34C759",
        "Value2": "#007AFF",
        "Value3": "#FFCC00",
        "Value4": "#00C7BE",
    },
    vehicleCharging: {
        "Value1": "#00C7BE",
        "Value2": "#007AFF",

      }
    }

    return (
        <div className={styles.container}>
            {Array.from(alternatives).map((alternative) => (
                <div key={alternative.id} className={styles.alternativeWrapper}>
                    <div className={styles.alternativeHeader}>
                        <div className={styles.headerTitle}>
                            <h1>{alternative.name}</h1>
                            {bestAlternative.id === alternative.id && <GreenLightningIcon size="16" tooltip={t('preferredAlternativeTooltip')} />}
                        </div>
                        <div className={styles.headerInfo}>
                            <p>{t('totalSqm', { total: toatal_sqm(alternative) })}</p>
                            <p>{t('residentialUnitsPrefix') + alternative.residental_unit_area_planned}</p>
                        </div>
                    </div>
                    <EnergyContent 
                        key={`energy-content-${alternative.id}`}
                        alternative={alternative}
                        consumptionColors={consumptionColors}
                        numberOfCompare={alternatives.size}
                    />
                </div>
            ))}
        </div>
    );
};